/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import beer from "../images/beer.png";
import glass from "../images/glass.png";
import iris from "../images/iris.jpg";
import leaf from "../images/leaf.jpg";
import wine from "../images/wine.png";
import data from "../images/default.jpg";
import vehicle from "../images/vehicle.jpg"
import acb from "../images/acb.jpg"
import pima from "../images/pima.jpg"
import oulad from "../images/oulad.jpg"
import bank from "../images/bank.jpg"
import Popup from "reactjs-popup";
import {CardHeader, Checkbox} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const styles = {
  root:{
    width:"30%"
  },
  card: {
    backgroundColor:"#e7e7e7",
    minWidth: 200,
    width: "30%",
    margin: 20,
    maxWidth: 400
  },
  media: {
    height: 140
  },
  buttonSelect: {
    fontSize: "16px",
    color: "#4caf50",
    width: "50%"
  },
  buttonConfiguration: {
    fontSize: "16px",
    color: "#e9bb06",
    width: "50%"
  },
  buttonInfo: {
    fontSize: "16px",
    color: "#687aff",
    width: "50%"
  },
  buttonDelete: {
    fontSize: "16px",
    color: "#ff3d00",
    width: "50%"
  }
};

function DatasetCard(props) {
  const { classes } = props;
  const [checked, setChecked] = useState(props.checked);

  function handleDatasetChange() {
    if (checked) {
      setChecked( false)
    } else {
      setChecked(  true)
    }
    props.handleDatasetClick(props.dataset,!checked)
  }
  useEffect(() => {
    setChecked( props.checked)
  });
  function handleDatasetClick(event) {

    props.handleDataset(event.currentTarget.id);
  }
  function handleConfigClick(event) {
    props.classifierDontExist("J48")
    props.goToBuilder(event.currentTarget.id);
  }

  function deleteDataset(event) {
    props.deleteDataset(event.currentTarget.id);
  }

  return (
    <Card className={classes.card}>
      <CardActionArea className={props.dataset.name} disabled>
        {props.dataset.name === "beer" ? (
          <CardMedia
            className={classes.media}
            image={beer}
            title={props.dataset.name}
          />
        ) : (
          ""
        )}
        {props.dataset.name === "glass" ? (
          <CardMedia
            className={classes.media}
            image={glass}
            title={props.dataset.name.toUpperCase()}
          />
        ) : (
          ""
        )}
        {props.dataset.name === "flavia" ? (
          <CardMedia
            className={classes.media}
            image={leaf}
            title={props.dataset.name.toUpperCase()}
          />
        ) : (
          ""
        )}
        {props.dataset.name === "wine" ? (
          <CardMedia
            className={classes.media}
            image={wine}
            title={props.dataset.name.toUpperCase()}
          />
        ) : (
          ""
        )}
        {props.dataset.name === "iris" ? (
          <CardMedia
            className={classes.media}
            image={iris}
            title={props.dataset.name.toUpperCase()}
          />
        ) : (
          ""
        )}
        {props.dataset.name === "vehicle" ? (
            <CardMedia
                className={classes.media}
                image={vehicle}
                title={props.dataset.name.toUpperCase()}
            />
        ) : (
            ""
        )}
        {props.dataset.name === "ACB" ? (
            <CardMedia
                className={classes.media}
                image={acb}
                title={props.dataset.name.toUpperCase()}
            />
        ) : (
            ""
        )}
        {props.dataset.name === "PIMA" ? (
            <CardMedia
                className={classes.media}
                image={pima}
                title={props.dataset.name.toUpperCase()}
            />
        ) : (
            ""
        )}
        {props.dataset.name === "OULAD" ? (
            <CardMedia
                className={classes.media}
                image={oulad}
                title={props.dataset.name.toUpperCase()}
            />
        ) : (
            ""
        )}
        {props.dataset.name === "bank" ? (
            <CardMedia
                className={classes.media}
                image={bank}
                title={props.dataset.name.toUpperCase()}
            />
        ) : (
            ""
        )}
        {props.dataset.name !== "beer" &&
          props.dataset.name !== "glass" &&
          props.dataset.name !== "flavia" &&
          props.dataset.name !== "wine" &&
          props.dataset.name !== "iris" &&
          props.dataset.name !== "vehicle" &&
          props.dataset.name !== "ACB" &&
          props.dataset.name !== "PIMA" &&
          props.dataset.name !== "OULAD" &&
          props.dataset.name !== "bank" &&(
            <CardMedia
              className={classes.media}c
              image={data}
              title={props.dataset.name.toUpperCase()}
            />
          )}
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {props.dataset.name.toUpperCase()}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions style={{marginTop:-20}}>
        {props.mode === "beginner" &&
        <FormControlLabel
            style={{width:"50%",color:"#4caf50",textAlign:"center"}}
            control={
              <Checkbox
                  style={{marginLeft:50}}
                  checked={checked}
                  onChange={handleDatasetChange}
                  value="checked"
                  color="primary"
              />
            }
            label={props.language.labels[props.language.id].select.toUpperCase()}
        />
        }
        {props.mode !== "beginner" &&
        <Button
            id={props.dataset.name}
            size="small"
            color="primary"
            onClick={handleDatasetClick}
            className={classes.buttonSelect}
        >
          {props.language.labels[props.language.id].select}
        </Button>
        }
        {(props.dataset.name === "beer" ||
              props.dataset.name === "glass" ||
              props.dataset.name === "flavia" ||
              props.dataset.name === "wine" ||
              props.dataset.name === "iris" ||
              props.dataset.name === "vehicle"||
              props.dataset.name === "ACB" ||
              props.dataset.name === "PIMA" ||
              props.dataset.name === "OULAD" ||
              props.dataset.name === "bank"
        ) &&(
        <Popup trigger={
        <Button
            id={props.dataset.name}
            size="small"
            className={classes.buttonInfo}
        >
          {props.language.labels[props.language.id].info}
        </Button>} modal >
          <Card >
            <CardHeader title={"Dataset "+props.dataset.name} />
            <CardMedia
                className={classes.media}
                image={props.dataset.name ==="beer" ? beer:
                    props.dataset.name ==="glass" ? glass:
                    props.dataset.name === "flavia" ? leaf:
                    props.dataset.name === "vehicle" ? vehicle:
                    props.dataset.name === "iris" ? iris:
                    props.dataset.name === "wine" ? wine:
                    props.dataset.name === "ACB" ? acb:
                    props.dataset.name === "PIMA" ? pima:
                    props.dataset.name === "OULAD" ? oulad:
                    props.dataset.name === "bank" ? bank:data}
                    title={props.dataset.name}
            />
            {props.dataset.name === "iris" &&
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].irisMessage1}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].irisMessage2}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                Fisher,R.A. "The use of multiple measurements in taxonomic problems", Annual Eugenics, 7, Part II,
                179-188 (1936)
              </Typography>
              <br/>
              <Typography variant="body" component="p" style={{textAlign: "justify"}}>
                <Link target="_blank" href="https://archive.ics.uci.edu/ml/datasets/Iris">
                  https://archive.ics.uci.edu/ml/datasets/Iris
                </Link>
              </Typography>
            </CardContent>
            }
            {props.dataset.name === "glass" &&
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].glassMessage1}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].glassMessage2}
              </Typography>
              <br/>
              <Typography variant="body" component="p" style={{textAlign: "justify"}}>
                <Link target="_blank" href="https://archive.ics.uci.edu/ml/datasets/Glass">
                  https://archive.ics.uci.edu/ml/datasets/Glass
                </Link>
              </Typography>
            </CardContent>
            }
            {props.dataset.name === "flavia" &&
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].flaviaMessage1}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                Jose M. Alonso, A. Ramos-Soto, Ehud Reiter, Kees van Deemter, "An Exploratory Study on the Benefits of using Natural Language for Explaining Fuzzy Rule-based Systems", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Naples, Italy, 2017, pp. 1–6,</Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].flaviaMessage2}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                S. Gang Wu, F. Sheng Bao, E. You Xu, Y.-X. Wang, Y.-F. Chang, and Q.-L. Xiang, "A leaf recognition algorithm for plant classification using probabilistic neural network", in IEEE International Symposium on Signal Processing and Information Technology, 2007, pp. 1–6.
              </Typography>
              <br/>
              <Typography variant="body" component="p" style={{textAlign: "justify"}}>
                <Link target="_blank" href="http://flavia.sourceforge.net/">
                  http://flavia.sourceforge.net/
                </Link>
              </Typography>
            </CardContent>
            }
            {props.dataset.name === "beer" &&
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].beerMessage1}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].beerMessage2}{" "}
                G. Castellano, C. Castiello, and A. M. Fanelli, "The FISDeT software: Application to beer style classification", in IEEE International Conference
                on Fuzzy Systems (FUZZ-IEEE), Naples, Italy, 2017, pp. 1–6,{" "}
                <Link target="_blank" href="https://dx.doi.org/10.1109/FUZZ-IEEE.2017.8015503">
                  https://dx.doi.org/10.1109/FUZZ-IEEE.2017.8015503
                </Link>
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].beerMessage3}{" "}
                Jose M. Alonso, Pietro Ducange, Riccardo Pecori, Raul Vilas, "Building Explainable Fuzzy Decision Trees with the ExpliClas Software", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Glasgow, Scotland, UK, 2020, pp. 1–8,
              </Typography>
              <br/>
            </CardContent>
            }
            {props.dataset.name === "vehicle" &&
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].vehicleMessage1}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].vehicleMessage2}{" "}
                J. P. Siebert, "Vehicle Recognition Using Rule Based Methods", in Turing Institute Research Memorandum TIRM-87-018, 1987
              </Typography>
              <br/>
              <Typography variant="body" component="p" style={{textAlign: "justify"}}>
                <Link target="_blank" href="https://archive.ics.uci.edu/ml/datasets/Vehicle">
                  https://archive.ics.uci.edu/ml/datasets/Vehicle
                </Link>
              </Typography>
            </CardContent>
            }
            {props.dataset.name === "wine" &&
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].wineMessage1}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].wineMessage2}
                Jose M. Alonso, Pietro Ducange, Riccardo Pecori, Raul Vilas, "Building Explainable Fuzzy Decision Trees with the ExpliClas Software", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Glasgow, Scotland, UK, 2020, pp. 1–8,
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].wineMessage3}
                An Extendible Package for Data Exploration, Classification and Correlation. Institute of Pharmaceutical and Food Analysis and Technologies, Via Brigata Salerno, 16147 Genoa, Italy.
              </Typography>
              <br/>
              <Typography variant="body" component="p" style={{textAlign: "justify"}}>
                <Link target="_blank" href="https://archive.ics.uci.edu/ml/datasets/Wine">
                  https://archive.ics.uci.edu/ml/datasets/Wine
                </Link>
              </Typography>
            </CardContent>
            }
            {props.dataset.name === "ACB" &&
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].acbMessage1}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].acbMessage2}{" "}
                Jose M. Alonso, "Explainable Artificial Intelligence for Kids", International Conference of the European Society for Fuzzy Logic and Applications (EUSFLAT), Prague, Czech Republic, pp. 1-8, 2019
              </Typography>
              <br/>
              <Typography variant="body" component="p" style={{textAlign: "justify"}}>
                <Link target="_blank" href="https://gitlab.citius.usc.es/jose.alonso/basketballplayers-dataset">
                  https://gitlab.citius.usc.es/jose.alonso/basketballplayers-dataset
                </Link>
              </Typography>
            </CardContent>
            }
            {props.dataset.name === "OULAD" &&
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].ouladMessage1}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].ouladMessage2}
                Jose M. Alonso, G. Casalino, "Explainable Artificial Intelligence for Human-Centric Data Analysis in Virtual Learning Environments", in Burgos, D., Cimitile, M., Ducange, P., Pecori, R., Picerno, P., Raviolo, P., Stracke, C.M. (Editors), Higher Education Learning Methodologies and Technologies Online, Springer, pp. 125-138,&nbsp;
                <Link target="_blank" href="http://dx.doi.org/10.1007/978-3-030-31284-8_10">
                  http://dx.doi.org/10.1007/978-3-030-31284-8_10
                </Link>
              </Typography>
            </CardContent>
            }
            {props.dataset.name === "PIMA" &&
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].pimaMesssage1}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].pimaMessage2}
                Jose M. Alonso, Pietro Ducange, Riccardo Pecori, Raul Vilas, "Building Explainable Fuzzy Decision Trees with the ExpliClas Software", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Glasgow, Scotland, UK, 2020, pp. 1–8,
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].pimaMessage3}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].pimaMessage4}
                <Link target="_blank" href="https://waikato.github.io/weka-wiki/datasets">
                  https://waikato.github.io/weka-wiki/datasets
                </Link>
              </Typography>
            </CardContent>
            }
            {props.dataset.name === "bank" &&
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].bankMessage1}
              </Typography>
              <br/>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                {props.language.labels[props.language.id].bankMessage2}
              </Typography>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
              Jose M. Alonso, A. Bugarin, "ExpliClas: Automatic Generation of Explanations in Natural Language for Weka Classifiers", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), New Orleans, USA, 2019, pp. 1–6,&nbsp;
                <Link target="_blank" href="http://dx.doi.org/10.1109%2FFUZZ-IEEE.2019.8859018">
                  http://dx.doi.org/10.1109%2FFUZZ-IEEE.2019.8859018
                </Link>
              </Typography>
            </CardContent>
            }
          </Card>
        </Popup>)
        }
        {props.dataset.name !== "beer" &&
          props.dataset.name !== "glass" &&
          props.dataset.name !== "flavia" &&
          props.dataset.name !== "wine" &&
          props.dataset.name !== "iris" &&
          props.dataset.name !== "vehicle" &&
          props.dataset.name !== "ACB" &&
          props.dataset.name !== "PIMA" &&
          props.dataset.name !== "OULAD" &&
          props.dataset.name !== "bank" &&(
              <>
            <Button
                id={props.dataset.name}
                size="small"
                color="primary"
                onClick={handleConfigClick}
                className={classes.buttonConfiguration}
            >
              {props.language.labels[props.language.id].configuration}
            </Button>
            <Button
              id={props.dataset.name}
              size="small"
              className={classes.buttonDelete}
              onClick={deleteDataset}
            >
              {props.language.labels[props.language.id].delete}
            </Button>
            </>
          )}
      </CardActions>
    </Card>
  );
}

DatasetCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DatasetCard);
